import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Table } from 'components/common/Elements/Elements';

import classes from '../PlatformActivitiesTable.module.scss';

const Cell = ({ children, cellProps, ...other }) => {
  const { row, big, mouseEnter, field, ind } = cellProps;
  return (
    <Table.Cell
      className={cn(
        classes.tableCell,
        row === `r${ind}` && classes.hov,
        classes[field],
        big && classes.row_big
      )}
      onMouseEnter={mouseEnter}
      {...other}
    >
      {children}
    </Table.Cell>
  );
};

Cell.propTypes = {
  children: PropTypes.node,
  cellClass: PropTypes.string,
  cellProps: PropTypes.shape({
    ind: PropTypes.number,
    field: PropTypes.string,
    row: PropTypes.string,
    mouseEnter: PropTypes.func,
    big: PropTypes.bool
  })
};

export default Cell;
